import { plural } from '@lingui/core/macro';
import { PackageDTO, PackageMountingEnum } from '@luminovo/api-contracts';
import { isPresent } from '@luminovo/commons';
import { Chip } from '@luminovo/design-system';

export function formatPackageLabel(
    numberOfPins: number | null | undefined,
    mounting: PackageMountingEnum | null | undefined,
    name: string | null,
) {
    const numberOfPinsLabel = numberOfPins
        ? plural(numberOfPins, { one: `• ${numberOfPins} pin`, other: `• ${numberOfPins} pins` })
        : undefined;

    return [mounting, name, numberOfPinsLabel].filter(isPresent).join(' ');
}

export const PackageChip = ({
    formfit: { name, mounting, number_of_pins },
    conflicts,
    disabled,
}: {
    formfit: PackageDTO;
    conflicts?: boolean;
    disabled?: boolean;
}): JSX.Element | null => {
    if (!mounting && !name) return null;
    const packageLabel = formatPackageLabel(number_of_pins, mounting, name);
    return <Chip color={conflicts ? 'red' : 'neutral'} label={packageLabel} disabled={disabled} />;
};
